import { cn } from '@/shared/utils/cn';

interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  circle?: boolean;
  className?: string;
}

/**
 * Skeleton - Componente de placeholder de carga
 *
 * Componente que muestra un placeholder animado mientras se carga el contenido.
 * Útil para mejorar la experiencia de usuario durante la carga de datos.
 *
 * @example
 * ```tsx
 * // Skeleton rectangular
 * <Skeleton width={200} height={20} />
 *
 * // Skeleton circular (para avatares)
 * <Skeleton width={40} height={40} circle />
 *
 * // Skeleton de ancho completo
 * <Skeleton height={16} />
 * ```
 */
export const Skeleton = ({ width, height = 20, circle = false, className }: SkeletonProps) => {
  const baseClasses = cn(
    'ui-imj',
    'ui-animate-pulse ui-bg-neutral-200',
    circle ? 'ui-rounded-control-pill' : 'ui-rounded',
    className,
  );

  const style = {
    width: typeof width === 'number' ? `${width}px` : width || '100%',
    height: typeof height === 'number' ? `${height}px` : height,
  };

  return <div className={baseClasses} style={style} />;
};
